module.exports = __webpack_public_path__ + "static/media/step_coachnew.4020276f.svg";